import { ResultTypeResult, SysIAnalitos } from './types.analitos';
import { SysA_AreasAnalisis, SysI_Estudios } from './types.estudios';
import { Paciente } from './types.patient';
import { contextPatient } from './types.system';
import { User } from './types.user';

export interface OrdersGlobal {
  //Indica si se está cargando algo.
  Loading: boolean;
  //Indica si hay un error
  Error?: string | null;
  //Indica si el panel derecho está pineado
  PanelPined: boolean;
  //Indica si el panel derecho está visible
  PanelVisible: boolean;
  //Indica si hay una orden actualmente filtrada
  CurrentOrder: SelectedOrder;
  //Listado de ordenes
  CurrentPatientToTransfer?: Paciente;
  // Listado de ordenes filtradas
  FilteredOrders: any[];
  // Filtro de ordenes aplicado.
  FiltersToOrders: FilteredOrders | null;
  // Texto descriptivo de los filtros aplicados
  FiltersToOrdersText: string[];
  // Filtros persistentes para resultados
  ResultsFilters: {
    selectedStates: number[];
  };
  // Tab actualmente activa en InfoOrder (1=Studies, 2=Results, 3=Notes, 4=Attachments, 5=Tracking, 6=SerumLibrary)
  currentActiveTab: number;
}

export interface ResultFilterRequest {
  states?: ResultEstadoResult[];
  areas?: number[];
  studies?: number[];
  tracking?: boolean;
}

export interface ModalResult {
  Update: boolean;
  Visible: boolean;
  An_Id: number;
  An_Nombre: string;
  Res_Id: number;
  Res_Estado: ResultEstadoResult;
  Res_Resultado: string | null;
  An_Plantilla?: string | null;
  An_Tr_Id?: ResultTypeResult;
  Pc_Id: number;
  Ord_Id?: number;
  Es_Id?: number;
}

export interface ModalResultMicrobiology {
  Update?: boolean;
  Visible: boolean;
  Ord_Id?: number;
  Es_Id?: number;
  Es_Nombre?: string;
  An_Id?: number;
  An_Nombre?: string;
  Res_Id?: number;
  Res_Estado?: ResultEstadoResult;
  Res_Resultado?: string | null;
  An_Plantilla?: string | null;
  An_Tr_Id?: ResultTypeResult;
  Pc_Id?: number;
}

export interface ModalResultMultiline {
  Update: boolean;
  Visible: boolean;
  An_Id: number;
  An_Nombre: string;
  Res_Id: number;
  Res_Estado: ResultEstadoResult;
  Res_Resultado: string | null;
  Pc_Id: number;
}

export type OrderSummary = {
  IdPreorden: number;
  IdOrder: number;
  OrderNumber: string;
  Success: boolean;
  Message: string;
};

export interface SelectedOrder {
  Mode: 'new' | 'update' | 'view' | 'loading';
  ModePatient: 'new' | 'update' | 'view';
  IdOrder?: number;
  OrderData?: any;
  StudiesData: StudiesAddType[];
  PatientData?: any;
  ModalStudies: boolean;
  ModalPatient: boolean;
  ContextPatient: contextPatient;
  NoFindedDocument: string;
  CreatePatientAndUpdate: boolean;
  ModalResultTemplate?: ModalResult;
  ModalResultImage?: ModalResult;
  ModalResultMicrobiology?: ModalResultMicrobiology;
  ModalResultMultiline?: ModalResultMultiline;
  ModalResultImagenesDx?: ModalResult;
  ModalNoteVal?: ModalResult;
  ModalHistory?: ModalResult;
  LoadingPatient: boolean;
  LoadingStudies: boolean;
  IdTransaction?: string | null;
  Notes?: Notas[];
  Attachments?: Attachments[];
  // Total de consentimientos de la orden (creados localmente + recibidos de otros labs). Para el badge.
  ConsentsCount?: number;
  Results?: SysIResultados[];
}

export type SelectedStudie = {
  combobox: 'Studies' | 'Profile' | null;
  data: StudiesAddType | null;
};

export type Attachments = {
  Oad_Id: number;
  Oad_Ord_Id: number;
  Oad_Es_Id: number | null;
  Oad_Nombre: string;
  Oad_Fecha: Date;
  Oad_Tamanno: number;
  Oad_Validate: boolean;
};

export type StudiesAddType = {
  Estado: boolean;
  Es_Id: number;
  Es_Aa_Id: number;
  Es_Codigo: string;
  Es_Nombre: string;
  Es_Lr_Id: number | null;
  Remitido: boolean;
  Accion: number;
  Editado: boolean;
  Profile?: string;
  Rpe_Pfe_Id?: number | undefined;
  AditionalFields?: any;
};

export interface Order {
  Ord_Id: number;
  Ord_Pc_Id: number;
  Ord_Sd_Id: number;
  Ord_Numero: string;
  Ord_FechaCreacion: string;
  Ord_FechaImpresion: string | null;
  Ord_EdadPaciente: number;
  Ord_Estado: boolean;
  Ord_Nota: string | null;
  Ord_Prioridad: number;
  Ord_Impresa: boolean;
  Ord_Cancelada: boolean;
  Ord_Importada: boolean;
  Ord_Seman_Emb: string | null;
  Paciente: Paciente | null;
  Servicio: Servicio | null;
}

export interface Servicio {
  Se_Id: number;
  Se_Nombre: string;
  Se_Color: string;
  Se_C_Homolog: string;
  Se_Descrip: string;
  Se_Estado: boolean;
}

export interface Notas {
  Nor_Id: number;
  Nor_Ord_Id: number;
  Nor_Us_Id: number;
  Nor_Fecha: Date;
  Nor_Nota: string;
  Usuarios: User;
}

export interface SysIResultados {
  Res_Id: number;
  Res_Ord_Id: number;
  Res_Es_Id: number;
  Res_An_Id: number;
  Res_Aa_Id: number;
  Res_Us_Id: number | null;
  Res_Um_Id: number | null;
  Res_Fecha: Date;
  Res_Estado: ResultEstadoResult | number;
  Res_EstadoMuestra: boolean;
  Res_Resultado: string | null;
  Res_ValRefMin: number | null;
  Res_ValRefMax: number | null;
  Res_UnidadMedida: string | null;
  Res_NotaValidacion: string | null;
  Res_FechaValidacion: Date | null;
  Res_FechaModificacion: Date | null;
  Res_NotaDesvalidacion: string | null;
  Res_ResultadoAnterior: string | null;
  Res_FechaResultadoAnterior: Date | null;
  Res_OrdenPrevio1: number | null;
  Res_ResultadoPrevio1: string | null;
  Res_FechaPrevio1: Date | null;
  Res_OrdenPrevio2: number | null;
  Res_ResultadoPrevio2: string | null;
  Res_FechaPrevio2: Date | null;
  Res_ResultadoPlantilla: string | null;
  Res_OrdenImpresion: number | null;
  Res_EnviadoCorreo: boolean | null;
  Res_FechaEnviadoCorreo: Date | null;
  Res_Impreso: boolean | null;
  Res_FechaImpresion: Date | null;
  Res_Remitido: boolean | null;
  Res_CodEnvio: string | null;
  Res_MuestraTrackedada: boolean | null;
  Res_EnviadoOtrasFuentes: ETypeExternalExportResult | null;
  Res_EnviadoOtrasFuentesFecha: Date | null;
  Analito: SysIAnalitos;
  Estudio: SysI_Estudios;
  Area: SysA_AreasAnalisis;
  Orden: Order;
}

export interface SendResultByEmail {
  IdOrder: number;
  Destinators: string[];
  Studies: number[];
  IncludeAttachments: boolean;
  IncludeAttachmentsStudies: boolean;
}

export interface SendResultByEmailMasive {
  DataOrder: SendResultByEmailMasiveOrder[];
  Studies?: number[];
  Areas?: number[];
  Destinators: string[];
  SendIndividual: boolean;
  Subject?: string;
  Body?: string;
}

export interface SendResultByEmailMasiveOrder {
  IdOrder: number;
  OrderNumber: string;
  Patient: string;
  Document: string;
}

export interface SendResultByWhatsApp {
  IdOrder: number;
  PhoneDestinator: string;
  Studies: number[];
  IncludeAttachments: boolean;
  IncludeAttachmentsStudies: boolean;
}

export enum ResultEstadoResult {
  SinResultado = 1,
  ConResultado = 2,
  Validado = 3,
  Impreso = 4,
  OtrasFuentes = 5,
  ValidadoBlanco = 6,
}

export interface DinamicFiltersOrders {
  FieldName: string;
  Label: string;
  Values: (string | number | boolean | null)[];
  DisplayValues?: string[]; // Valores textuales para mostrar en UI
}

export interface FilteredOrders {
  IdOrden?: number;
  Fechas: (string | null)[] | (Date | null)[];
  Orden?: string[];
  Paciente?: number;
  Areas?: number[];
  Estudios?: number[];
  Servicios?: number[];
  Sedes?: number[];
  Estados?: ResultEstadoResult[];
  Tracking?: boolean;
  Redirect?: boolean;
  Remitido?: boolean;
  UpdateFilter?: boolean;
  CamposDinamicos?: DinamicFiltersOrders[];
}

export interface CashierFilter {
  Fechas: [string, string];
  PacDocument: string;
  Ordenes: [string | null, string | null];
  Usuarios: number[];
  Servicios: number[];
  Contratos: number[];
  Estado: boolean | null;
}

export enum ETypeExternalExportResult{
  CorreoElectronico = 1,
  HistoriaClinica = 2,
  PaginaWebResultados = 3,
  SistemaExterno = 4,
  WhatsApp = 5,
}
